import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../../../styles.scss'

const TestServer = props => (
    <li key={props.serverId}>
        <label htmlFor={`test-server-${props.name}`}>
            <input
                type="checkbox"
                id={`test-server-${props.name}`}
                onChange={props.update}
                checked={props.checked}
            />
            <span className={styles.checkbox} />
            {props.name}
        </label>
    </li>
)

TestServer.propTypes = {
    name: PropTypes.string,
    serverId: PropTypes.string,
    checked: PropTypes.bool,
    update: PropTypes.func,
}

export default TestServer



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/TestServers/components/TestServer/index.js